/* CIUFOLI — theme behaviour.
   No dependencies. No scroll hijacking, parallax or cursor replacement (§16).
   Motion never conceals content and is never required to understand a work. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --------------------------------------------- focus trap utility */
  var SELECTOR = 'a[href],button:not([disabled]),input:not([disabled]),' +
                 'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trap(container, e) {
    var nodes = Array.prototype.filter.call(
      container.querySelectorAll(SELECTOR), function (n) { return n.offsetParent !== null; });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* --------------------------------------------- mobile navigation §8 */
  var mnav = document.querySelector('[data-mobile-nav]');
  var mtrigger = document.querySelector('[data-menu-trigger]');
  if (mnav && mtrigger) {
    var lastFocus = null;
    var setMenu = function (open) {
      mnav.setAttribute('data-open', open ? 'true' : 'false');
      mtrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mtrigger.textContent = open ? mtrigger.getAttribute('data-label-close')
                                  : mtrigger.getAttribute('data-label-open');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocus = document.activeElement;
        var f = mnav.querySelector(SELECTOR);
        if (f) f.focus();
      } else if (lastFocus) { lastFocus.focus(); }
    };
    mtrigger.addEventListener('click', function () {
      setMenu(mnav.getAttribute('data-open') !== 'true');
    });
    mnav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenu(false);
      if (e.key === 'Tab') trap(mnav, e);
    });
  }

  /* ------------------------------------------------- search overlay §9 */
  var overlay = document.querySelector('[data-search-overlay]');
  if (overlay) {
    var searchLast = null;
    var setSearch = function (open) {
      overlay.setAttribute('data-open', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        searchLast = document.activeElement;
        var input = overlay.querySelector('input[type="search"]');
        if (input) input.focus();
      } else if (searchLast) { searchLast.focus(); }
    };
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-search-open]'), function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); setSearch(true); });
      });
    Array.prototype.forEach.call(
      overlay.querySelectorAll('[data-search-close]'), function (b) {
        b.addEventListener('click', function () { setSearch(false); });
      });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setSearch(false);
      if (e.key === 'Tab') trap(overlay, e);
    });
    // "/" opens search when focus is not already in a field (§6)
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
      var t = e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || e.target.isContentEditable) return;
      e.preventDefault();
      setSearch(true);
    });
  }

  /* --------------------------------------------- section reveal once §16 */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        ro.unobserve(entry.target);            // once per element
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
      ro.observe(el);
    });
  } else {
    Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) {
      el.classList.add('is-in');
    });
  }

  /* ------------------------------------- chapter index current state §9 */
  var chapters = document.querySelectorAll('[data-chapter]');
  var chapterLinks = document.querySelectorAll('[data-chapter-link]');
  if (chapters.length && chapterLinks.length && 'IntersectionObserver' in window) {
    // Updates the visible index only. The URL changes on deliberate
    // navigation, never on scroll position (§9).
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.getAttribute('id');
        Array.prototype.forEach.call(chapterLinks, function (link) {
          var match = link.getAttribute('href') === '#' + id;
          if (match) { link.setAttribute('aria-current', 'true'); }
          else { link.removeAttribute('aria-current'); }
        });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Array.prototype.forEach.call(chapters, function (c) { co.observe(c); });
  }

  /* --------------------------------------------- authored media gallery */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-gallery]'), function (gallery) {
      var frames = gallery.querySelectorAll('[data-frame]');
      var controls = gallery.querySelectorAll('[data-frame-control]');
      if (!frames.length) return;
      var show = function (index) {
        Array.prototype.forEach.call(frames, function (f, i) {
          var on = i === index;
          f.hidden = !on;
          f.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        Array.prototype.forEach.call(controls, function (c, i) {
          c.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      };
      Array.prototype.forEach.call(controls, function (c, i) {
        c.addEventListener('click', function () { show(i); });
        c.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          next = (next + controls.length) % controls.length;
          controls[next].focus();
          show(next);
        });
      });
      show(0);
    });

  /* ------------------------------ film: poster first, visible pause §16 */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-film]'), function (film) {
      var video = film.querySelector('video');
      var toggle = film.querySelector('[data-film-toggle]');
      if (!video) return;
      // Reduced motion replaces autoplay with the poster; controls remain (§16)
      if (reduced.matches) { video.removeAttribute('autoplay'); video.pause(); }
      if (!toggle) return;
      var sync = function () {
        var playing = !video.paused;
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        toggle.textContent = playing ? toggle.getAttribute('data-label-pause')
                                     : toggle.getAttribute('data-label-play');
      };
      toggle.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
})();

/* Work-page index. Marks the section currently in view. Purely a reading
   aid: the links work with JavaScript disabled, and nothing is hidden. */
(function () {
  var nav = document.querySelector('[data-railnav]');
  if (!nav) return;

  var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
  var targets = links
    .map(function (a) { return document.querySelector(a.getAttribute('href')); })
    .filter(Boolean);
  if (!targets.length) return;

  function mark(id) {
    links.forEach(function (a) {
      a.classList.toggle('is-current', a.getAttribute('href') === '#' + id);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) mark(entry.target.id);
    });
  }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

  targets.forEach(function (t) { observer.observe(t); });
})();

/* ------------------------------------------ the work an enquiry concerns
   It arrives as ?work= from the work page. Shopify Liquid cannot read a
   query string, so the reference is read from the address here and written
   into the form — into the visible field, so the visitor can correct it,
   and into the register above it, so they can see what the enquiry is
   about before they send it. */
(function () {
  'use strict';
  var input = document.getElementById('e-work');
  if (!input) return;

  var ref = '';
  try { ref = new URLSearchParams(window.location.search).get('work') || ''; }
  catch (e) { return; }

  ref = ref.replace(/[<>]/g, '').trim().slice(0, 120);
  if (!ref) return;

  if (!input.value) input.value = ref;

  var dl = document.querySelector('[data-concerns]');
  var dd = dl && dl.querySelector('[data-concerns-value]');
  if (dd) { dd.textContent = ref; dl.hidden = false; }
})();
